import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';


function AddTimesheetForm({ caseId: propCaseId, onTimesheetAdded }) {
  const [formData, setFormData] = useState({
    caseId: propCaseId || '',
    clientName: '',
    task: '',
    duration: '',
    notes: '',
    billable: false,
  });

  const [cases, setCases] = useState([]);

  // Fetch cases only if caseId is not provided
  useEffect(() => {
    if (!propCaseId) {
      const fetchCases = async () => {
        try {
          const token = localStorage.getItem("token");

          const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/projects`,{
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          });
        
          setCases(res.data);
        } catch (error) {
          console.error('Error fetching cases:', error);
        }
      };
      fetchCases();
    }
  }, [propCaseId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");


    if (!formData.caseId) {
      alert('Please select a case.');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/timesheets`, formData,{
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      onTimesheetAdded();
      setFormData({
        caseId: propCaseId || '',
        clientName: '',
        task: '',
        duration: '',
        notes: '',
        billable: false,
      });
           toast.success("Timesheet added successfully!");
    } catch (error) {
      console.error('Failed to add timesheet:', error);
      toast.error("Failed to add timesheet!");

    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-4 shadow rounded-xl space-y-4 border border-gray-200">

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Case dropdown only if not inside CaseDetails */}
        {!propCaseId && (
          <div>
            <label className="block mb-1 font-medium">Project</label>
            <select
              name="caseId"
              value={formData.caseId}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">Select Project</option>
              {cases.map((caseItem) => (
                <option key={caseItem._id} value={caseItem._id}>
                  {caseItem.caseTitle}
                </option>
              ))}
            </select>
          </div>
        )}
       
     
      </div>
      <input
          name="clientName"
          placeholder="Client Name"
          value={formData.clientName}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        />
        <input
          name="task"
          placeholder="Task"
          value={formData.task}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        />
        <input
          name="duration"
          type="number"
          placeholder="Duration (minutes)"
          value={formData.duration}
          onChange={handleChange}
          className="border p-2 rounded"
          required
        />
      <textarea
        name="notes"
        placeholder="Notes"
        value={formData.notes}
        onChange={handleChange}
        required

        className="w-full border p-2 rounded"
      />
      <label className="inline-flex items-center p-2">
        <input
          type="checkbox"
          name="billable"
          checked={formData.billable}
          onChange={handleChange}
          className="mr-2"
        />
        Billable
      </label>
      <button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
        Add Entry
      </button>
    </form>
  );
}

export default AddTimesheetForm;
